import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PostHogProvider } from 'posthog-js/react';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';

// Sentry: production-only error monitoring.
// Set REACT_APP_SENTRY_DSN in your Vercel environment variables.
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_DSN) {
  import('@sentry/react').then(Sentry => {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      // Capture 10% of transactions for performance monitoring (adjust as needed)
      tracesSampleRate: 0.1,
      // Only report errors from your own domain, not third-party scripts
      allowUrls: [/iconboard\.site/],
      // Ignore common noise
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'Non-Error promise rejection',
        /Loading chunk \d+ failed/,
      ],
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// Only enable PostHog in production to avoid development console noise
const AppWithAnalytics = process.env.NODE_ENV === "production" && process.env.REACT_APP_POSTHOG_API_KEY ? (
  <PostHogProvider
    apiKey={process.env.REACT_APP_POSTHOG_API_KEY}
    options={{
      api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
      defaults: '2025-05-24',
      capture_exceptions: true,
      debug: false,
    }}
  >
    <App />
  </PostHogProvider>
) : <App />;

root.render(
  <React.StrictMode>
    {AppWithAnalytics}
  </React.StrictMode>,
);

// Register service worker for PWA functionality
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onSuccess: () => {},
    onUpdate: (registration) => {
      // Optionally show toast notification to user
      if (window.confirm('New version available! Reload to update?')) {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        window.location.reload();
      }
    },
  });
}